import type { Project, ProjectBudgetStatus } from '../../lib/api'
import { hasBudgetData } from '../../lib/budget-view'
import { Select } from '../ui/select'

export function BudgetProjectSelect({
  projects,
  statusByProject,
  selectedId,
  onChange,
}: {
  projects: Project[]
  statusByProject: Record<string, ProjectBudgetStatus | undefined>
  selectedId: string | null
  onChange: (projectId: string) => void
}) {
  const active = projects.filter((p) => hasBudgetData(statusByProject[p.id]))
  const other = projects.filter((p) => !hasBudgetData(statusByProject[p.id]))
  return (
    <Select
      aria-label="Kontingent-Projekt"
      value={selectedId ?? ''}
      onChange={(e) => onChange(e.target.value)}
      className="h-9 min-w-0 text-xs"
    >
      {!selectedId && <option value="">Projekt wählen</option>}
      {active.length > 0 && (
        <optgroup label="Mit aktivem Kontingent">
          {active.map((p) => (
            <option key={p.id} value={p.id}>
              {p.name}
            </option>
          ))}
        </optgroup>
      )}
      {other.length > 0 && (
        <optgroup label="Weitere Projekte">
          {other.map((p) => (
            <option key={p.id} value={p.id}>
              {p.name}
            </option>
          ))}
        </optgroup>
      )}
    </Select>
  )
}
